<template>
  <div class="good-item">
    <div style="">
      <div class="good-img">
        <a @click="goodsDetails(msg.productId)">
          <img :src="imgUrl" :alt="msg.productName">
        </a>
      </div>
      <h6 class="good-title" v-html="msg.title">{{msg.title}}</h6>
      <h3 class="sub-title ellipsis">{{msg.subTitle}}</h3>
      <div class="good-price pr">
        <div class="ds pa">
         <a @click="goodsDetails(msg.productId)">
            <y-button text="查看详情" style="margin: 0 5px"></y-button>
          </a>
<!--          <y-button text="加入购物车"
                    style="margin: 0 5px"
                    @btnClick="addCart(msg.productId,msg.salePrice,msg.productName,msg.productUrl)"
                    classStyle="main-btn"
          ></y-button> -->
          <y-button text="立即购买" style="margin: 0 5px" classStyle="main-btn" @btnClick="openDialog"></y-button>
        </div>
       <p><span style="font-size:14px">￥</span>{{Number(msg.price).toFixed(2)}}</p>
      </div>
    </div>
  </div>
</template>
<script>
  import YButton from '/components/YButton'
  import { addCart } from '/api/goods.js'
  import { mapMutations, mapState } from 'vuex'
  import { getStore } from '/utils/storage'
  export default {
    props: {
      msg: {
        salePrice: 0
      }
    },
    data () {
      return {
        selectParams:{
          search: '',
        	sort: 'weigh',
        	order: 'asc',
        	page: 1,
        	filter: {},
        	op: {},
          open:false,
        },
        imgUrl:'',
      }
    },
    methods: {
      openDialog(){
        console.log('click')
        this.open = true
        this.$emit('openDialog',this.open)
      },
      goodsDetails (id) {
        // window.open('//' + window.location.host + '/#/goodsDetail?productId=' + id)
        // this.$router.push({path: 'goodsDetails/productId=' + id})
        // window.open('//' + window.location.host + '/#/productDetails?productId=' + id)

        // let url = this.$router.replace({
        //   name:'productDetails',
        //   query:{data:JSON.stringify(this.msg)}
        // })
        // this.$router.push(url,'_blank')
        // 假设 this.msg 是你想要携带的对象
        const url = this.$router.resolve({
          name: 'productDetails',
          query: { data: JSON.stringify(this.msg) }
        }).href;

        // 使用 window.open 在新标签页打开 URL，而不在当前标签页跳转
        window.open(url, '_blank');
      },
      openProduct (id) {
        window.open('//' + window.location.host + '/#/goodsDetail?productId=' + id)
      },
      addCart (id, price, name, img) {
        setTimeout(()=>{
          if (this.cart.showMoveImg) {
            this.$store.commit('cart/addanimation',{moveShow: false})
          }
        },2000)
        if (!this.cart.showMoveImg) {     // 动画是否在运动
          if (this.user.isLogin) { // 登录了 直接存在用户名下
              addCart({userId: getStore('userId'), productId: id, productNum: 1}).then(res => {
              // 并不重新请求数据
              this.$store.commit('cart/addcart',{productId: id, salePrice: price, productName: name, productImg: img})
            })
          } else { // 未登录 vuex
            this.$store.commit('cart/addcart',{productId: id, salePrice: price, productName: name, productImg: img})
          }
          // 加入购物车动画
          var dom = event.target
          // 获取点击的坐标
          let elLeft = dom.getBoundingClientRect().left + (dom.offsetWidth / 2)
          let elTop = dom.getBoundingClientRect().top + (dom.offsetHeight / 2)
          // 需要触发
          this.$store.commit('cart/addanimation',{moveShow: true, elLeft: elLeft, elTop: elTop, img: img})
          if (!this.cart.showCart) {
            this.$store.commit('cart/showcart',{showCart: true})
          }
        }
      },
    },
    computed: {
      ...mapState(['user', 'cart'])
    },
    mounted () {
      this.imgUrl = this.$yxz.oss_img(this.msg.images[0])
    },
    components: {
      YButton
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../assets/style/mixin";
  @import "../assets/style/theme";

  .good-item {
    border-right: 1px solid #efefef;
    border-bottom: 1px solid #efefef;
    background: #fff;
    width: 25%;
    transition: all .5s;
    height: 380px;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 1px 1px 20px #999;
      .good-price p {
        display: none;
      }
      .ds {
        display: flex;
      }
    }

    .ds {
      @extend %block-center;
      width: 100%;
      display: none;
    }

    .good-img {
      img {
        border-radius: 5px;
        margin: 40px auto 10px;
        @include wh(205px);
        display: block;
      }
    }

    .good-price {
      height: 30px;
      text-align: center;
      line-height: 30px;
      color: #d44d44;
      font-family: Arial;
      font-size: 18px;
      font-weight: 700;
    }

    .good-title {
      line-height: 1.3;
      font-size: 16px;
      color: #424242;
      margin: 0 auto;
      padding: 0 15px;
      text-align: center;
      overflow: hidden;
    }

    h3 {
      text-align: center;
      line-height: 1.1;
      font-size: 12px;
      color: #d0d0d0;
      padding: 10px;
    }

  }
</style>



// WEBPACK FOOTER //
// mallGoods.vue?7b270f98